import { cilLocationPin } from "@coreui/icons";
import { HiMiniFlag } from "react-icons/hi2";
import CIcon from "@coreui/icons-react";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CFormInput,
  CFormLabel,
  CInputGroup,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import ReactSelect from "react-select";
import api from "src/api/axios";
import GpsLocationModal from "src/components/GPSLocation/GpsLocationModal";
import { getDriverGpsLocation } from "src/services/gps-location.services";
import moment from "moment";
import { getCountryList } from "src/services/country.services";
import axios from "axios";
import { removeArabic } from "src/uitils/commonFunction";

const ManageGpsLocation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const defaultErrorMessage = "Unable to fetch location data";
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [plateNumber, setPlateNumber] = useState("");
  const [driverName, setDriverName] = useState("");
  const [status, setStatus] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const isFirstRun = useRef(true);
  const user= JSON.parse(localStorage.getItem("user"));
  const [countries,setCountries]= useState([]);
  const [places,setPlaces]= useState({});
  const [batchSize,setBatchSize]= useState(10);


  const fetchPlaceName = async (lat, lon) => {
    let token = "pk.eyJ1Ijoid3NpdC1zYW1pdWwiLCJhIjoiY2xqM3g1b3FoMWtpODNyb2RmM2V1aTJzbCJ9.u870I5zQLy6w3dWBby5siw"
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=${token}&language=en`;
    const response = await fetch(url);
    const data = await response.json();
    return data.features?.length > 0 ? data.features[0].place_name : "No place found";
  };

  const getLatLongIndex=(lat,lon)=>{
    if(lat==null || lon==null){
      return Math.random()
    }
    return lat?.toString()+","+lon?.toString()
  }

  const processLocationsInBatches = async (locations) => {
    let index = 0;
  
    while (index < locations.length) {
      const batch = locations.slice(index, index + batchSize);
      const results = await Promise.all(batch.map(({ lat, lon }) => fetchPlaceName(lat, lon)));
  
      setPlaces((prevPlaces) => {
        const newPlaces = { ...prevPlaces };
        batch.forEach((loc, i) => {
          newPlaces[getLatLongIndex(loc.lat, loc.lon)] = results[i];
        });
        return newPlaces;
      });
  
      index += batchSize;
      await new Promise((resolve) => setTimeout(resolve, 500)); // Prevent API throttling
    }
  };
  
  const getLatsLongs=(isOld)=>{
    let latsLongs=[];
    locationData.forEach((item) => {
        if(!places[getLatLongIndex(item.deviceStatus?.currentPosition?.latitude,item.deviceStatus?.currentPosition?.longitude)]){
          latsLongs.push({
            lat: item.deviceStatus?.currentPosition?.latitude,
            lon: item.deviceStatus?.currentPosition?.longitude,
          })
        }
    })
    console.log(latsLongs)
    return latsLongs
  }
  useEffect(() => {
    if(locationData.length<=0){
      return
    }
    if(Object.keys(places).length>0){
      processLocationsInBatches(getLatsLongs(true))
      return
    };
    processLocationsInBatches(getLatsLongs())
  },[locationData])

  useEffect(() => {
    console.log(places)
  },[places])
  const getCountries=async()=>{
     getCountryList({limit:99,page:1})
     .then((response) => {
       setCountries(response.data);
     })
  }
 
  useEffect(() => {
    if(countries.length>1){
      return
    }
    if (user?.userType === "superAdmin") {
     getCountries();
    }
  }, [user]);

  const getLocationData = async (params = null) => {
    try {
      setIsLoading(true);
      // toast.loading("Fetching location data...");
      const response = await getDriverGpsLocation(params);
      if (response.status === 200 && response.data.success) {
        const data = response.data.locationData;
        // setLocationData(data);
        let moving=[];
        let others=[];
        if (Array.isArray(data) && data.length > 0) {
          data.forEach((item) => {
            if(item.deviceStatus.currentPosition?.speed > 0 &&
              !item.deviceStatus.idlingState?.isCurrentlyIdling){
              moving.push(item)
            }else{
              others.push(item)
            }
          })
          setLocationData([...moving,...others]);
        } else {
          setLocationData([]);
        }
      } else {
        toast.error(response.data.message || defaultErrorMessage);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || defaultErrorMessage);
    } finally {
      setIsLoading(false);
      toast.dismiss();
    }
  };

  //onchage search text
  const handleSearchChange = (e) => {};

  const onClickSearchSubmit = (plateNumber, driverName, status, selectedCountry) => {
    // toast.loading("Fetching location data...");
    const params = new URLSearchParams();
    if (plateNumber) {
      params.append("plateNumber", plateNumber);
    }
    if (driverName) {
      params.append("driverName", driverName);
    }
    if (status) {
      params.append("status", status.value);
    }
    if (selectedCountry) {
      params.append("country_id", selectedCountry._id);
      params.append("countryName", selectedCountry.name);
      params.append("countryCode", selectedCountry.code);
    }
    getLocationData(params);
  };

  const calculateDuration = (timestamp) => {
    const currentTime = moment();
    const updateTime = moment(timestamp);
    const duration = moment.duration(currentTime.diff(updateTime));
    const days = Math.max(0, Math.floor(duration.asDays()));
    const hours = duration.hours();
    const minutes = duration.minutes();
    return `${days} Days, ${hours} Hrs, ${minutes} Mins`;
  };

  const handleReset = () => {
    setPlateNumber("");
    setDriverName("");
    setStatus("");
    setSelectedCountry(null);
    getLocationData();
  };

  const formatOdometerReading = (reading) => {
    return (reading / 1000).toFixed(2);
  };

  useEffect(() => {
    if (isFirstRun.current) {
      getLocationData();
      isFirstRun.current = false;
    }

    const intervalId = setInterval(() => {
      onClickSearchSubmit(plateNumber, driverName, status, selectedCountry);
    }, 1 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [plateNumber, driverName, status, selectedCountry]);
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={12} md={4} lg={user?.userType==="superAdmin"?3:4}>
              <CFormLabel htmlFor="plateNumber">Plate Number</CFormLabel>
              <CFormInput
                type="text"
                placeholder="example: DXB-55712-Q"
                value={plateNumber}
                onChange={(e) => setPlateNumber(e.target.value)}
              />
            </CCol>
            <CCol sm={12} md={4} lg={user?.userType==="superAdmin"?3:4}>
              <CFormLabel htmlFor="driverName">Driver Name</CFormLabel>
              <CFormInput
                type="text"
                placeholder="type driver name here..."
                value={driverName}
                onChange={(e) => setDriverName(e.target.value)}
              />
            </CCol>
            <CCol sm={12} md={4} lg={user?.userType==="superAdmin"?3:4}>
              <CFormLabel htmlFor="bookingOrderId">Status</CFormLabel>
              <ReactSelect
                value={status}
                options={[
                  {
                    value: "moving",
                    label: "Moving",
                  },
                  {
                    value: "stopped",
                    label: "Stopped",
                  },
                  {
                    value: "idle",
                    label: "Idle",
                  },
                ]}
                placeholder="Select status"
                onChange={(e) => setStatus(e)}
              />
            </CCol>
           {user?.userType==="superAdmin" ? (
             <CCol sm={12} md={4} lg={user?.userType==="superAdmin"?3:4}>
             <CFormLabel htmlFor="bookingOrderId">Country</CFormLabel>
             <ReactSelect
               value={selectedCountry}
               options={countries}
               placeholder="Select Country"
               getOptionLabel={(e) => e.name} // Map the custom label field
               getOptionValue={(e) => e._id}  // Map the custom value field
               onChange={(e) => setSelectedCountry(e)}
             />
           </CCol>
           ):""}
          </CRow>
          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="submit"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={()=>{toast.loading("Fetching location data..."); onClickSearchSubmit(plateNumber, driverName, status, selectedCountry)}}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 ms-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow className="justify-content-between">
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Live Vehicle Tracking
              </h4>
              {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
            </CCol>
            <CCol sm={3} className=" d-md-block  text-end">
              <CButton className="btn btn-primary"
              >
                <Link to={"/gps-location-report"} className="text-decoration-none text-white">History</Link></CButton>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  S.No
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Status
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Plate Number
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">Map</CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Driver
                </CTableHeaderCell>
                
                <CTableHeaderCell className="text-center">
                  Location
                </CTableHeaderCell>
                 <CTableHeaderCell className="text-center">
                  Location Time
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Speed
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Odometer
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Last Status Duration
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Alert
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Trip ID
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Vehicle Type
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading && isFirstRun.current ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="16">Loading...</CTableDataCell>
                </CTableRow>
              ) : locationData.length > 0 ? (
                locationData.map((data, index) => (
                  <CTableRow className="gps_row" key={index}>
                    <CTableDataCell className="text-center">
                      {index + 1}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {data.deviceStatus.currentPosition?.speed > 0 && (
                          <CButton
                            size="sm"
                            color="success"
                            className="text-white"
                            style={{ width: "80px" }}
                          >
                            Moving
                          </CButton>
                        )}
                      {data.deviceStatus.currentPosition?.speed == 0 &&
                        data.deviceStatus.ignition?.state && (
                          <CButton
                            size="sm"
                            color="warning"
                            className="text-white"
                            style={{ width: "80px" }}
                          >
                            Idle
                          </CButton>
                        )}
                      {data.deviceStatus.currentPosition?.speed == 0 &&
                        !data.deviceStatus.ignition?.state && (
                          <CButton
                            size="sm"
                            color="danger"
                            className="text-white"
                            style={{ width: "80px" }}
                          >
                            Stopped
                          </CButton>
                        )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {data.asset.plateNumber}
                      {/* {data?.deviceStatus?.tagScanStatus?.tag ?? data?.driver?.tagId } */}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CButton
                        size="sm"
                        onClick={() => setSelectedDevice(data)}
                      >
                        <CIcon icon={cilLocationPin} />
                      </CButton>
                    </CTableDataCell>
                    <CTableDataCell className="text-center fw-bold">
                      {data.driver
                        ? `${
                            data?.driver?.firstName +
                            " " +
                            data?.driver?.lastName
                          }`
                        : "....."}
                    </CTableDataCell>
                    
                    <CTableDataCell className="text-center fw-bold text-uppercase">
                      {removeArabic(places[getLatLongIndex(data.deviceStatus.currentPosition?.latitude,data.deviceStatus.currentPosition?.longitude)])}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {moment(
                        data.deviceStatus.currentPosition?.updateTimestamp
                      ).format("DD-MMM-YYYY HH:mm")}
                    </CTableDataCell>

                    <CTableDataCell className={`text-center ${data.deviceStatus.currentPosition?.speed >= 100 ? "emergency-color" : ""}`}>
                      {data.deviceStatus.currentPosition?.speed} km/h
                    </CTableDataCell>

                    <CTableDataCell className="text-center">
                      {formatOdometerReading(
                        data.deviceStatus.odometer?.gpsOdometer
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {calculateDuration(
                        data.deviceStatus.accelerometerState?.updateTimestamp
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {data.isFlaged && <HiMiniFlag color="red" />}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {data.driver?.trip ? (
                        <Link
                          to={`/manage-trip/orders/${data.driver.trip.tripId}`}
                          target="_blank"
                          style={{
                            color:
                              "var(--cui-table-color-state, var(--cui-table-color-type, var(--cui-table-color)))",
                          }}
                        >
                          {data.driver.trip.tripId}
                        </Link>
                      ) : (
                        "...."
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {`${data.asset.brand} ${data.asset.model}`}
                    </CTableDataCell>
                  </CTableRow>
                ))
              ) : isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="16">Loading...</CTableDataCell>
                </CTableRow>
              ) : (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="16">
                    There is no data!!
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>
        </CCardBody>
      </CCard>

      {selectedDevice && (
        <GpsLocationModal {...{ selectedDevice, setSelectedDevice }} />
      )}
    </>
  );
};

export default ManageGpsLocation;
